// Copyright (c) 2017 Deere & Company

import * as actions from '../../actions-list';
import {getDefaultState} from '../state';

const resetClaimNumber = () => getDefaultState().claimNumber;

const updateClaimNumber = (state, action) => action.claimNumber;

export default (state = getDefaultState().claimNumber, action) => {

    const actionTypes = {
        [actions.RESET_TCSM_CLAIM_DEBIT]: resetClaimNumber,
        [actions.UPDATE_TCSM_CLAIM_DEBIT_CLAIM_NUMBER]: updateClaimNumber
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/tcsm/claim-debit/reducers/claim-number.js